import consolv from 'lib/consolv';
import waitForDependency from 'lib/waitForDependency';

const defaultConfig = {
	enabled: false,
	scriptTimeout: 500,
	failsafeTimeout: 750,
	pubId: 925660,
};

/**
 * @description Intercepts ad refresh events and triggers IAS slot analyzing function
 * Use ?iasdebug=true to enable debugging
 */
const setupBeforeRefresh = (MCP, config) => ({ slots, addAsyncEvent }) => {
	const runPerformanceTest = MCP._config.performanceTest === true;
	const startTime = runPerformanceTest ? window.performance.now() : null;

	const asyncEvent = new Promise((resolve) => {
		const { __iasPET: iasPET } = window;
		const { failsafeTimeout } = config;
		let failsafeTimerRef;

		const adSlots = Array.from(slots.values())
			.filter(slot => slot.meta.blockIAS !== true)
			.map((slot) => ({
				adSlotId: slot.id,
				size: slot.sizeMap.map((size) => size === 'fluid' ? [1, 1] : size),
				adUnitPath: slot.adUnitPath,
			}));

		if (!adSlots.length) return;

		consolv.log('MCP IAS: Ad slots for IAS', adSlots);

		const dataHandler = (targeting) => {
			window.clearTimeout(failsafeTimerRef);

			if (!targeting) {
				consolv.log('MCP IAS: No targeting received');
				resolve();
				return;
			}

			iasPET?.setTargetingForGPT();

			// TODO: Maybe parse targeting and set individual KVPs on slots?

			let parsedTargeting;
			try {
				parsedTargeting = JSON.parse(targeting);
			} catch (e) {}

			consolv.log(
				'MCP IAS: Targeting received',
				parsedTargeting,
				runPerformanceTest ? `${(window.performance.now() - startTime) / 1000} seconds` : null,
			);

			resolve();
		};

		if (Array.isArray(!iasPET.queue)) return;
		iasPET.queue.push({
			adSlots,
			dataHandler,
		});

		// Unnecessary?
		// iasPET.start();

		/* eslint-disable-next-line prefer-const */
		failsafeTimerRef = window.setTimeout(() => {
			consolv.log(`MCP IAS: Failsafe timeout exceeded at ${failsafeTimeout} seconds`);
			resolve();
		}, failsafeTimeout);
	});

	addAsyncEvent(asyncEvent);
};

/**
 * Generates the configuration and sets up event listeners for slot loads
 * @param {MCPInstance} MCP
 */
export default function IASAdapter(MCP) {
	MCP.loaded.then(() => {
		const { ias: iasConfig } =
			MCP.Configurator.getConfiguration({ defaults: { ias: defaultConfig } });

		if (!iasConfig.enabled) return;

		const waitForIasPET = waitForDependency(() => window.__iasPET, iasConfig.scriptTimeout);

		MCP.addEventListener('initialized', ({ addAsyncEvent }) => {
			// Delays MCP initialization until IAS has loaded or hits the timeout
			const asyncEvent = waitForIasPET.then((iasPET) => {
				if (!iasPET) throw new Error('iasPET global not found');

				if (!iasConfig.pubId) throw new Error('PubId not defined');
				iasPET.pubId = iasConfig.pubId;

				MCP.addEventListener('beforeRefreshSlots', setupBeforeRefresh(MCP, iasConfig));
			}).catch((e) => {
				consolv.log('MCP IAS: Error', e);
			});

			addAsyncEvent(asyncEvent);
		});
	});
}
